/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { useTranslations } from '../../hooks/useTranslations';
import { Link, MessageStrip } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';

const InfoComponent = () => {
    const { t } = useTranslations();

    return (
        <MessageStrip
            data-testid="infoComponent"
            style={{ padding: ThemingParameters.sapContent_Padding_M }}
            design="Information"
            hideCloseButton={true}
        >
            {t('MESSAGESTRIP_PREFIX')}{' '}
            <Link design="Emphasized" href={'https://itsm.services.sap/sp?id=index'} target="_blank">
                BNS-ARI-FRE
            </Link>{' '}
            {t('MESSAGESTRIP_SUFFIX')}
        </MessageStrip>
    );
};

export default InfoComponent;
